import Vue from 'vue';
import 'moment-timezone';
import moment from 'moment-timezone';


Vue.filter("modate", function(value) {
    return moment(value.toDate()).format('MM/DD/YYYY')
});

Vue.filter("dateformatforfirebase", function(value, format) {
    //console.log('value', value);
    //return moment(value.toDate()).format(format);
    const milliseconds = value.seconds * 1000 + Math.floor(value.nanoseconds/1000000);

    // Create a moment object using the milliseconds 
    const momentTime = moment(milliseconds);
    return momentTime.format(format);
});

Vue.filter("dateformatwithtz", function(value, timezone, format) {
    let temp = moment(value).tz(timezone);
    //let fmtStr = timezone && timezone.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    if(temp !== undefined)
        return value === '' || value === null ? '' : temp.format(format);
});

Vue.filter("dateformat", function(value, format) {
    //console.log(`got ${value} with tz= ${timezone} in dateformat`);
    //let fmtStr = timezone && timezone.toUpperCase() === 'AFRICA/MASERU' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    if(value && value !== null && value !== '')
        return moment(value).format(format);
    else
        return '';
});

Vue.filter("dateformatwithtime", function(value, timezone) {
    if(value) {
        //console.log(`value:${value}, tz:${timezone}`);
        if(timezone) {
            // Parse the datetime as if it's already in the clinic's timezone (not UTC)
            let temp = moment.tz(value, timezone);
            //console.log(`temp:${temp}`);
            if(temp !== undefined)
                return temp.format('MM/DD/YYYY h:mm a');
        } else {
            return moment(value).format('MM/DD/YYYY h:mm a');
        }
    }
});

Vue.filter("timeformatold", function(value, timezone) {
    let ret;
    if(value) {
        console.log(`in timeformatwithtz, value:${value}, tz:${timezone}`);
        if(timezone) {
            //let temp = moment.utc(value).tz(timezone);
            let temp = moment(value).tz(timezone);
            console.log(`in timeformatwithtz after applying TZ function, temp:${temp}`);
            if(temp !== undefined)
                ret = temp.format('h:mm a');
        } else {
            ret = moment(value).format('h:mm a');
        }
    }
    console.log(`returning ${ret} from timeformat`);
    return ret;
});

Vue.filter("timeformatwithtz", function(value, timezone) {
    let ret;
    if(value) {
        console.log(`in timeformat, value:${value}, tz:${timezone}`);      
        let a = moment.utc(value).tz(timezone).format('hh:mm a');
        let b = moment(value).tz(timezone).format('hh:mm a');
        let c = moment(value).format('hh:mm a');  
        let e = moment.utc(value).format('hh:mm a');
        //console.log(`a: ${a}, b: ${b}, c: ${c}, e: ${e}`);  
        ret = e;
    }
    console.log(`returning ${ret} from timeformat`);
    return ret;
});

Vue.filter("money", function (value, currencySymbol) {
    let temp;
    currencySymbol = currencySymbol ? currencySymbol : '$';

    if(value === 0)
        return '$0.00';
    
    if(!value) {
        temp = 0.00;
    } else {
        try {
            temp = parseFloat(value);
            return currencySymbol + temp.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        } catch(e) {
            return '$0.00';
        }
    }
});

/*
Vue.filter("truncate", function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
});
*/